import { Dialog, DialogContent } from "@mui/material";
import { useEffect, useState } from "react";
import { VerificationProcessService } from "../../Component/Api/VerificationAgency/VerificationProcess/VerificationProcessService";
import { VerificationProcess } from "../../Component/Model/Dto/VerificationAgency/VerificationProcessTracker";
import { CustomDialogTitle } from "../Common/Custom/CustomDialogTitle";
import { VerificationProcessTrackerEditForm } from "../VerificationAgency/BEEScorecards/VerificationStatusTrackerEditForm";

interface IProps {
    id: number
    scorecardId: string
    showModal: boolean;
    closeModal: () => void;
}

export const ScorecardVerificationProcessTrackerEdit = (props: IProps) => {

    const [verificationProcessUpdateFormDataReq, setVerificationProcesssUpdateFormDataReq] = useState<VerificationProcess.VerificationProcessDto | any>();
    const [showVerificationProcessUpdateForm, setShowVerificationProcessUpdateForm] = useState<boolean>(false);

    useEffect(() => {
        fetchFormData(props.id)
    }, [props.id]);


    const fetchFormData = async (id: number) => {
        try {
            const result = await VerificationProcessService.GetVerificationProcess(id);
            setVerificationProcesssUpdateFormDataReq(result.data);
        } catch (error) {
            console.log(error)
        } finally {
            setShowVerificationProcessUpdateForm(true);
        }
    }

    return (
        <>
            <Dialog open={showVerificationProcessUpdateForm} onClose={props.closeModal} aria-labelledby="form-dialog-title" maxWidth='lg' fullWidth>
                <CustomDialogTitle id="customized-dialog-title" onClose={props.closeModal}>
                    Verification Process Edit
                </CustomDialogTitle>
                <DialogContent>
                    <VerificationProcessTrackerEditForm
                        id={props.id}
                        scorecardId={props.scorecardId}
                        showModal={props.showModal} 
                        formData={verificationProcessUpdateFormDataReq} 
                        closeModal={props.closeModal} />
                </DialogContent>
            </Dialog>
        </>
    )
}